// 新闻管理
const userManage = () => import('@/view/user-manage/user-manage'); //
const userDetail = () => import('@/view/user-manage/user-detail'); //
const authorization = () => import('@/view/user-manage/authorization'); //
const popularize = () => import('@/view/user-manage/popularize'); //
const record = () => import('@/view/user-manage/record'); //
const examine = () => import('@/view/user-manage/examine'); //
const examine2 = () => import('@/view/user-manage/examine2'); //
const examineDetail = () => import('@/view/user-manage/examine-detail'); //
const examineDetail2 = () => import('@/view/user-manage/examine-detail2'); //
const agentManage = () => import('@/view/user-manage/agent-manage'); //
const agentRecord = () => import('@/view/user-manage/agent-record'); //

const regionalAgent = () => import('@/view/user-manage/regional-agent'); //
const regionalAgentRecord = () => import('@/view/user-manage/regional-agent-record'); //
const vicePresident = () => import('@/view/user-manage/vice-president'); //
const president = () => import('@/view/user-manage/president'); //
const brandOwner = () => import('@/view/user-manage/brand-owner'); //

export default [{
        path: '/user-manage',
        name: 'userManage',
        component: userManage
    },
    {
        path: '/user-detail',
        name: 'userDetail',
        component: userDetail
    }, {
        path: '/authorization',
        name: 'authorization',
        component: authorization
    },
    {
        path: '/popularize',
        name: 'popularize',
        component: popularize
    }, {
        path: '/record',
        name: 'record',
        component: record
    }, {
        path: '/examine',
        name: 'examine',
        component: examine
    }, {
        path: '/examine2',
        name: 'examine2',
        component: examine2
    }, {
        path: '/examine-detail',
        name: 'examineDetail',
        component: examineDetail
    }, {
        path: '/examine-detail2',
        name: 'examineDetail2',
        component: examineDetail2
    },
    {
        path: '/agent-manage',
        name: 'agentManage',
        component: agentManage
    }, {
        path: '/agent-record',
        name: 'agentRecord',
        component: agentRecord
    }, {
        path: '/regional-agent',
        name: 'regionalAgent',
        component: regionalAgent
    }, {
        path: '/regional-agent-record',
        name: 'regionalAgentRecord',
        component: regionalAgentRecord
    }, {
        path: '/vice-president',
        name: 'vicePresident',
        component: vicePresident
    }, {
        path: '/president',
        name: 'president',
        component: president
    }, {
        path: '/brand-owner',
        name: 'brandOwner',
        component: brandOwner
    }
];